// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';



import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video


import 'vue-toast-response/maybe/vue-toast-response.css'
import VTS from 'vue-toast-response'
Vue.use(VTS)
Vue.use(ElementUI)

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.config.productionTip = false

// var url_post = 'https://pftraining.qspfwadmin.com';
// var url_post = 'https://peixun.qspfw.com/api';
//var url_post = 'http://peixun.qsfzpx.com/api';
//var url_post = 'https://guopei.qspfw.com/api2021';
var url_post = 'https://www.qspfw.cn/apiNew';
//var url_post = 'http://127.0.0.1:8221/api';
// axios.defaults.baseURL = 'https://pftraining.qspfwadmin.com';
// axios.defaults.baseURL = 'https://guopei.qspfw.com/api2021';
axios.defaults.baseURL = 'https://www.qspfw.cn/apiNew';
//axios.defaults.baseURL = 'http://127.0.0.1:8221/api';
//axios.defaults.baseURL = 'http://peixun.qsfzpx.com/api';
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
Vue.prototype.$http=axios
Vue.prototype.url_post=url_post
Vue.use(VueAwesomeSwiper)



// 全局导航钩子
 router.beforeEach((to, from, next) => {
    // 判断该路由是否需要登录权限
    if (to.meta.requireAuth) {
        // 通过vuex state获取当前的token是否存在
        // console.log(isEmptyObject(store.state.user))
        var token = localStorage.getItem('token');
        if(!!token) {
            next();
        }
        else {
            next({
                path: '/login',
                // query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
        }
    }
    else {
        next();
    }
 })


//post提交
var _this = this;
Vue.prototype.post = function (url,data,callback){
	var token  = localStorage.getItem('token');
	//处理提交的数据
	var postData = JSON.stringify(data);
	postData = JSON.parse(postData);
  console.log(postData);
	// if(!token) _this.$router.push('/');
	axios({
		url:url_post+url,
		method:'POST',
		dataType:'json',
		headers:{'content-type':'application/json','source':0,'access-token':token},
		data:postData,
  }).then((res)=>{
    if(res.data.status == 3){
    	//清存储
    	localStorage.removeItem('token');
      // _this.$router.push('/');
    }
    callback(res.data);
  }).catch((err)=>{
    console.log(err);
  })
}

!function(n){
    var  e=n.document,
        t=e.documentElement,
        i=750,
        d=i/90,
        o="orientationchange"in n?"orientationchange":"resize",
        a=function(){
            var n=t.clientWidth||320;n>750&&(n=750);
            t.style.fontSize=n/d+"px"
        };
    e.addEventListener&&(n.addEventListener(o,a,!1),e.addEventListener("DOMContentLoaded",a,!1))
}(window);

//时间格式化函数
function padLeftZero(str){
	return ('00'+str).substr(str.length);
}
Number.prototype.c_time = function (fmt){
	var date = this;
    if(/(y+)/.test(fmt)){
        date= new Date(date*1000);
        fmt = fmt.replace(RegExp.$1,(date.getFullYear()+"").substr(4-RegExp.$1.length));
        var o ={
            'M+':date.getMonth()+1,
            'd+':date.getDate(),
            'h+':date.getHours(),
            'm+':date.getMinutes(),
            "s+":date.getSeconds()
        }
        for(var k in o){
            if(new RegExp(`(${k})`).test(fmt)){
                var str =o[k]+'';
                fmt = fmt.replace(RegExp.$1,(RegExp.$1.length ===1) ? str : padLeftZero(str));
            }
        }
        return fmt;
    }
};


// 秒转时分秒
Number.prototype.hms = function (s){
    var second = parseInt(s);
    let hr = parseInt(second / 60 / 60 % 24);
    let min = parseInt(second / 60 % 60);
    let sec = parseInt(second % 60);
    hr = hr > 9 ? hr : '0' + hr;
    min = min > 9 ? min : '0' + min;
    sec = sec > 9 ? sec : '0' + sec;

    return hr+':'+min+':'+sec
};
Vue.filter('hms',function(s) {
	return parseInt(s).hms(s);
})

// 秒转分秒
Number.prototype.ms = function (s){
    var second = parseInt(s);
    let min = parseInt(second / 60 % 60);
    let sec = parseInt(second % 60);
    min = min > 9 ? min : '0' + min;
    sec = sec > 9 ? sec : '0' + sec;

    return min+':'+sec
};
Vue.filter('ms',function(s) {
	return parseInt(s).ms(s);
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js